export default __webpack_public_path__ + "static/media/ellipsTrachtZwei.74fd49fa.png";